export const ALL_RECORDS_CQL = 'cql.allRecords=1';
export const CQL_OR_OPERATOR = 'or';
export const CQL_AND_OPERATOR = 'and';
